import React, { useEffect, useMemo, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { getAdminCallActive } from "../../redux/actions/adminPortal_callActiveAction";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddMinuteHistory,
  getHistory,
  postAddMinuteHistory,
} from "../../redux/actions/adminPortal_historyAction";
import { getAllUsers } from "../../redux/actions/userAction";
import {
  getAdminResellersList,
  getAdminUsersList,
} from "../../redux/actions/adminPortal_listAction";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageTitle from "../common/PageTitle";
const drawerWidth = 240;

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "48px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-4px !important",
    },
    "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "11.5px 14px",
    },
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto", // Adjust row height to make it more compact
          },
        },
      },
      defaultProps: {
        density: "compact", // Set default density to compact
        exportButton: true,
      },
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function AdminHistory({ colorThem }) {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [userId, setUserId] = useState("");
  const [resellerId, setResellerId] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [tMinutes, setTMinutes] = useState("");
  const [open, setOpen] = React.useState(false);
  const [users, setUsers] = useState([]);
  const [resellers, setResellers] = useState([]);
  const [hide, setHide] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setTMinutes("");
    setUserId("");
    setResellerId("");
    setFromDate();
    setToDate();
  };

  useEffect(() => {
    dispatch(getAdminCallActive());
    dispatch(getAllUsers("t"));
    dispatch(getHistory({}));
    dispatch(getAddMinuteHistory());
    dispatch(postAddMinuteHistory({}));
    dispatch(getAdminUsersList());
    dispatch(getAdminResellersList());
  }, []); // Empty dependency array ensures this effect runs once on mount

  useMemo(() => {
    if (state?.getAdminUsersList?.userList) {
      const usersArray = Object.keys(state?.getAdminUsersList?.userList)?.map(
        (key) => ({
          user_id: key,
          username: state?.getAdminUsersList?.userList[key],
        }),
      );
      setUsers(usersArray);
    }
    if (state?.getAdminResellersList?.resellerList) {
      const resellerArray = Object.keys(
        state?.getAdminResellersList?.resellerList,
      )?.map((key) => ({
        reseller_id: key,
        username: state?.getAdminResellersList?.resellerList[key],
      }));
      setResellers(resellerArray);
    }
  }, [
    state?.getAdminUsersList?.userList,
    state?.getAdminResellersList?.resellerList,
  ]);

  const handleFromDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY", true).isValid()) {
      // Convert the selected date to the desired format before updating state
      setFromDate(dayjs(date).format("DD/MM/YYYY"));
    } else {
      setFromDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY", true).isValid()) {
      // Convert the selected date to the desired format before updating state
      setToDate(dayjs(date).format("DD/MM/YYYY"));
    } else {
      setToDate(null);
    }
  };

  const handleSearch = (e) => {
    // Convert fromDate and toDate to YYYY-MM-DD format
    e.preventDefault();
    const formattedFromDate = fromDate
      ? dayjs(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    const formattedToDate = toDate
      ? dayjs(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    let data = JSON.stringify({
      user_id: userId,
      reseller_id: resellerId,
      from_date: formattedFromDate,
      to_date: formattedToDate,
    });
    dispatch(getHistory(data));
    setHide(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setTMinutes("");
    setUserId("");
    setResellerId("");
    setFromDate();
    setToDate();
    dispatch(getHistory({}));
    setHide(false);
  };

  const handleSearchModal = (e) => {
    // Convert fromDate and toDate to YYYY-MM-DD format
    e.preventDefault();
    const formattedFromDate = fromDate
      ? dayjs(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    const formattedToDate = toDate
      ? dayjs(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    let data = JSON.stringify({
      user_id: userId,
      from_date: formattedFromDate,
      to_date: formattedToDate,
    });
    dispatch(postAddMinuteHistory(data));

    setHide(true);
  };

  const handleResetModal = (e) => {
    e.preventDefault();
    setTMinutes("");
    setUserId("");
    setResellerId("");
    setFromDate();
    setToDate();
    dispatch(postAddMinuteHistory({}));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs")); // < 600px
  const isSm = useMediaQuery(theme.breakpoints.only("sm")); // 600px - 900px
  const isMd = useMediaQuery(theme.breakpoints.only("md")); // 900px - 1200px
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("sm"));

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      headerClassName: "custom-header",
      cellClassName: "super-app-theme--cell",
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          S.No
        </Typography>
      ),
      renderCell: (params) => (
        <span style={{ fontSize: "calc(0.6rem + 0.2vw)" }}>
          {params.row.id}
        </span>
      ),
    },

    {
      field: "username",
      headerName: "User Name",
      flex: 1,
      minWidth: 130,
      headerClassName: "custom-header",
      cellClassName: "super-app-theme--cell",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          User name
        </Typography>
      ),
      renderCell: (params) => (
        <span
          style={{
            textTransform: "capitalize",
            fontSize: "calc(0.6rem + 0.2vw)",
          }}
        >
          {params.row.username}
        </span>
      ),
    },
    {
      field: "added_by",
      headerName: "Added By",
      width: isXs ? 80 : 160,
      minWidth: 80,
      maxWidth: 160,
      headerClassName: "custom-header",
      cellClassName: "super-app-theme--cell",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Added By
        </Typography>
      ),
      renderCell: (params) => (
        <span
          style={{
            textTransform: "capitalize",
            fontSize: "calc(0.6rem + 0.2vw)",
          }}
        >
          {params.row.added_by}
        </span>
      ),
    },
    {
      field: "topup",
      headerName: "Bucket",
      width: isXs ? 80 : 130,
      minWidth: 80,
      maxWidth: 130,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: isMobile ? "center" : "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Bucket
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "added_date",
      headerName: "Date",
      //cellClassName: "name-column--cell",
      //headerClassName: 'super-app-theme--header'
      // editable: true,
      width: isXs ? 100 : 130,
      minWidth: 100,
      maxWidth: 130,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Date
        </Typography>
      ),
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1; // Month starts from 0
          var year = date.getUTCFullYear();

          // Formatting single-digit day/month with leading zero if needed
          day = (day < 10 ? "0" : "") + day;
          month = (month < 10 ? "0" : "") + month;

          // Formatting single-digit hours/minutes/seconds with leading zero if needed

          var formattedDate = day + "/" + month + "/" + year + " ";
          return (
            <>
              <span style={{ color: "blue", fontSize: "calc(0.6rem + 0.2vw)" }}>
                {day}/{month}/{year}
              </span>
            </>
          );
        }
      },
    },

    {
      field: "added_time",
      headerName: "Time",
      width: isXs ? 80 : 130,
      minWidth: 80,
      maxWidth: 130,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Time
        </Typography>
      ),
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var hours = date.getUTCHours();
          var minutes = date.getUTCMinutes();
          var seconds = date.getUTCSeconds();
          hours = (hours < 10 ? "0" : "") + hours;
          minutes = (minutes < 10 ? "0" : "") + minutes;
          seconds = (seconds < 10 ? "0" : "") + seconds;
          var formattedDate = hours + ":" + minutes + ":" + seconds;
          return (
            <>
              <span
                style={{ color: "green", fontSize: "calc(0.6rem + 0.2vw)" }}
              >
                {hours}:{minutes}:{seconds}
              </span>
            </>
          );
        }
      },
    },
    {
      field: "reseller_name",
      headerName: "Reseller Name",

      minWidth: 100,
      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Reseller Name
        </Typography>
      ),
      renderCell: (params) => (
        <span
          style={{
            textTransform: "capitalize",
            fontSize: "calc(0.6rem + 0.2vw)",
          }}
        >
          {params.row.reseller_name}
        </span>
      ),
    },
  ];

  const columns1 = [
    {
      field: "S.No",
      headerName: "S.No",
      headerClassName: "custom-header",
      width: 80,
      headerAlign: "center",
      align: "center",
      cellClassName: "super-app-theme--cell",
    },

    {
      field: "user",
      headerName: "User Name",
      headerClassName: "custom-header",
      width: 150,
      headerAlign: "center",
      align: "center",
      cellClassName: "super-app-theme--cell",
    },
    {
      field: "total_add_minutes",
      headerName: "Total Add Minutes",
      headerClassName: "custom-header",
      width: 200,
      headerAlign: "center",
      align: "center",
      cellClassName: "super-app-theme--cell",
    },
  ];

  const classes = useStyles();

  // Function to determine whether a row should have the bordered style
  const isRowBordered = (params) => {
    const { row } = params;

    // Add your condition here, for example, adding border to rows where age is greater than 25
    return row.disposition === "ANSWERED";
  };

  const rows = [];
  state?.getAdminHistory?.getHistory?.data &&
    state?.getAdminHistory?.getHistory?.data?.forEach((item, index) => {
      rows.push({
        id: index + 1,
        added_by: item.added_by,
        added_date: item.added_date,
        added_time: item.added_date,
        topup: item.topup,
        username: item.username,
        user_id: item.user_id,
        historyId: item.id,
        reseller_name: item.reseller_name,
      });
    });

  const rows1 = [];
  state?.postAdminAddMinute?.addMinute &&
    state?.postAdminAddMinute?.addMinute?.forEach((item, index) => {
      rows1.push({
        id: index + 1,
        total_add_minutes: item.total_add_minutes,
        user: item.username,
        user_id: item.user_id,
      });
    });

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="">
                    {/* <!----> */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {/* <!--role-contet--> */}
                        <div className="cntnt_title d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-block">
                          <PageTitle title="Billing History" />
                        </div>
                        <div
                          className="cntnt_title mobile_justify_end"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "end",
                          }}
                        >
                          <div className="d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none">
                            <PageTitle title="Billing History" />
                          </div>

                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="child-modal-title"
                            aria-describedby="child-modal-description"
                          >
                            <Fade
                              in={open}
                              className="bg_imagess"
                              style={{ padding: "10px", borderRadius: "15px" }}
                            >
                              <Box sx={{ ...style, width: 700 }}>
                                <IconButton
                                  onClick={handleClose}
                                  sx={{ float: "inline-end" }}
                                >
                                  <Close />
                                </IconButton>

                                <Typography
                                  id="transition-modal-title"
                                  variant="h6"
                                  component="h2"
                                  color={"#092b5f"}
                                  fontSize={"18px"}
                                  fontWeight={"600"}
                                  marginBottom={"16px"}
                                  className="text-center modal_heading"
                                >
                                  Check Add Minute
                                </Typography>
                                <form
                                  style={{
                                    textAlign: "center",
                                    textAlign: "center",
                                    height: "auto",
                                    overflow: "auto",
                                    paddingTop: "10px",
                                    padding: "5px",
                                  }}
                                >
                                  <Grid
                                    container
                                    className="cdr_filter_row"
                                    style={{
                                      padding: "20px 0",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Grid
                                      xl={4}
                                      lg={4}
                                      md={4}
                                      sm={12}
                                      xs={12}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <FormControl
                                        fullWidth
                                        style={{
                                          width: "98%",
                                          margin: "7px 0",
                                        }}
                                        className={classes.formControl}
                                      >
                                        <InputLabel id="demo-simple-select-label">
                                          UserName
                                        </InputLabel>

                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          label="UserName"
                                          helperText="Select the language."
                                          style={{ textAlign: "left" }}
                                          value={userId}
                                          onChange={(e) => {
                                            setUserId(e.target.value);
                                          }}
                                          required
                                        >
                                          {users?.map((item, index) => {
                                            return (
                                              <MenuItem
                                                key={index}
                                                value={item?.user_id}
                                              >
                                                {item.username}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    <Grid
                                      xl={4}
                                      lg={4}
                                      md={4}
                                      sm={12}
                                      xs={12}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "53px",
                                      }}
                                    >
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        className={classes.formControl}
                                      >
                                        <DemoContainer
                                          components={["DatePicker"]}
                                          sx={{ width: "98%" }}
                                        >
                                          <DatePicker
                                            label="From Date"
                                            style={{ width: "auto" }}
                                            value={
                                              fromDate
                                                ? dayjs(fromDate, "DD/MM/YYYY")
                                                : null
                                            } // Convert selectedDate to a dayjs object
                                            onChange={handleFromDateChange}
                                            renderInput={(props) => (
                                              <TextField {...props} />
                                            )}
                                            format="DD/MM/YYYY"
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>
                                    </Grid>
                                    <Grid
                                      xl={4}
                                      lg={4}
                                      md={4}
                                      sm={12}
                                      xs={12}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "53px",
                                      }}
                                    >
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        className={classes.formControl}
                                      >
                                        <DemoContainer
                                          components={["DatePicker"]}
                                          sx={{ width: "98%" }}
                                        >
                                          <DatePicker
                                            label="To Date"
                                            style={{ width: "98%" }}
                                            value={
                                              toDate
                                                ? dayjs(toDate, "DD/MM/YYYY")
                                                : null
                                            } // Convert selectedDate to a dayjs object
                                            onChange={handleToDateChange}
                                            renderInput={(props) => (
                                              <TextField {...props} />
                                            )}
                                            format="DD/MM/YYYY"
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    className="cdr_filter_row"
                                    style={{ padding: "0px 0" }}
                                  >
                                    <Grid
                                      xl={12}
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "end",
                                        padding: "0px 0",
                                      }}
                                    >
                                      <IconButton
                                        className="filter_search_btn"
                                        style={{
                                          marginLeft: "0 !important",
                                          background: "green !important",
                                        }}
                                        onClick={handleSearchModal}
                                      >
                                        Search &nbsp;
                                        <SearchIcon />
                                      </IconButton>
                                      <IconButton
                                        className="filter_reset_btn"
                                        style={{
                                          marginLeft: "0 !important",
                                          backgroundColor: "grey !important",
                                        }}
                                        onClick={handleResetModal}
                                      >
                                        Reset &nbsp;
                                        <RestartAltIcon />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                  <br />

                                  <Box>
                                    <ThemeProvider theme={theme}>
                                      <div
                                        style={{
                                          height: "300px",
                                          width: "100%",
                                        }}
                                      >
                                        <DataGrid
                                          rows={rows1}
                                          columns={columns1}
                                          headerClassName="custom-header"
                                          // getRowClassName={(params) =>
                                          //   isRowBordered(params)
                                          //     ? classes.borderedGreen
                                          //     : classes.borderedRed
                                          // }
                                          components={{ Toolbar: GridToolbar }}
                                          slots={{
                                            toolbar: CustomToolbar,
                                          }}
                                        />
                                      </div>
                                    </ThemeProvider>
                                  </Box>
                                </form>
                                <Box></Box>
                              </Box>
                            </Fade>
                          </Modal>

                          {/* -----   Edit Modal End   ----- */}
                        </div>

                        <Grid
                          container
                          spacing={1.5}
                          className="cdr_filter_row"
                          sx={{ py: 1 }}
                        >
                          {/* User */}
                          <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <FormControl fullWidth size="small">
                              <InputLabel>UserName</InputLabel>
                              <Select
                                label="UserName"
                                value={userId}
                                onChange={(e) => setUserId(e.target.value)}
                              >
                                {users?.map((item) => (
                                  <MenuItem
                                    key={item.user_id}
                                    value={item.user_id}
                                  >
                                    {item.username}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          {/* Reseller */}
                          <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <FormControl fullWidth size="small">
                              <InputLabel>Reseller Name</InputLabel>
                              <Select
                                label="Reseller Name"
                                value={resellerId}
                                onChange={(e) => setResellerId(e.target.value)}
                              >
                                {resellers?.map((item) => (
                                  <MenuItem
                                    key={item.reseller_id}
                                    value={item.reseller_id}
                                  >
                                    {item.username}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          {/* From Date */}
                          <Grid item xl={2.5} lg={2.5} md={3} sm={6} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="From Date"
                                value={
                                  fromDate
                                    ? dayjs(fromDate, "DD/MM/YYYY")
                                    : null
                                }
                                onChange={handleFromDateChange}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: { size: "small", fullWidth: true },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>

                          {/* To Date */}
                          <Grid item xl={2.5} lg={2.5} md={3} sm={6} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="To Date"
                                value={
                                  toDate ? dayjs(toDate, "DD/MM/YYYY") : null
                                }
                                onChange={handleToDateChange}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: { size: "small", fullWidth: true },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>

                          {/* Buttons */}
                          <Grid
                            item
                            xl={3}
                            lg={3}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: {
                                md: "flex-end",
                                xs: "flex-end",
                              },

                            }}
                          >

                            <IconButton
                              className="filter_search_btn"
                              style={{
                                marginLeft: "0 !important",
                                background: "green !important",
                              }}
                              onClick={handleSearch}
                            >
                              {" "}
                              Search &nbsp; <SearchIcon />{" "}
                            </IconButton>{" "}
                            <IconButton
                              className="filter_reset_btn"
                              style={{
                                marginLeft: "0 !important",
                                backgroundColor: "grey !important",
                              }}
                              onClick={handleReset}
                            >
                              {" "}
                              Reset &nbsp; <RestartAltIcon />{" "}
                            </IconButton>
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          className="cdr_filter_row"
                          style={{ padding: "0px 0" }}
                        ></Grid>

                        <Box
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          <Typography
                            style={{
                              fontSize: "17px",
                              fontWeight: 600,
                              color: "rgb(66, 118, 95)",
                              padding: "5px 0",
                            }}
                          >
                            {hide === false ? (
                              <>
                                Total Top-Up Bucket:&nbsp;
                                <span>
                                  {state?.getAdminHistory?.getHistory
                                    ?.total_topup || 0}
                                </span>
                              </>
                            ) : (
                              <>
                                Total Top-Up: &nbsp;
                                <span>
                                  {state?.getAdminHistory?.getHistory
                                    ?.total_topup || 0}
                                </span>{" "}
                              </>
                            )}
                          </Typography>
                        </Box>
                        <ThemeProvider theme={theme}>
                          <div style={{ height: "100%", width: "100%" }}>
                            <StyledDataGrid
                              rows={rows}
                              columns={columns}
                              headerClassName="custom-header"
                              // getRowClassName={(params) =>
                              //   isRowBordered(params)
                              //     ? classes.borderedGreen
                              //     : classes.borderedRed
                              // }
                              components={{ Toolbar: GridToolbar }}
                              slots={{
                                toolbar: CustomToolbar,
                              }}
                              autoHeight
                              density="compact"
                              sx={{
                                "& .MuiDataGrid-toolbarContainer": {
                                  gap: "1px", // Spacing between buttons
                                },
                                "& .MuiButton-root": {
                                  // Targets all buttons (filter, export, density)
                                  fontSize: "calc(0.6rem + 0.4vw)", // Button text size
                                  minWidth: "unset", // Remove minimum width constraint
                                },
                                "& .MuiSvgIcon-root": {
                                  // Icons inside buttons
                                  fontSize: "calc(0.6rem + 0.4vw)", // Adjust icon size
                                },
                              }}
                            />
                          </div>
                        </ThemeProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AdminHistory;
